// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Array from "../../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Float from "../../../../../../node_modules/rescript/lib/es6/belt_Float.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as StringUtils from "../../../../rnr/utils/StringUtils.bs.js";
import * as SliderMarkingCmp from "./SliderMarkingCmp.bs.js";
import * as PartnerScoreHelper from "../../../domain/helper/PartnerScoreHelper.bs.js";
import * as SliderTrackSpanCmp from "./SliderTrackSpanCmp.bs.js";
import * as PartnerScoreAssetConfig from "../../assets/PartnerScoreAssetConfig.bs.js";
import * as PartnerScoreV2CssHelper from "../../../domain/helper/PartnerScoreV2CssHelper.bs.js";
import * as LockedSliderTrackMilestoneCmp from "./LockedSliderTrackMilestoneCmp.bs.js";

function LockedScoreSliderV2(Props) {
  var track_thresholds = Props.track_thresholds;
  var current_score = Props.current_score;
  var max_score = Props.max_score;
  var action_details = Props.action_details;
  return React.createElement("div", {
              className: "locked-slider-container-v2"
            }, React.createElement("div", {
                  className: "locked-slider-track-container-v2"
                }, React.createElement("img", {
                      className: "locked-slider-thumb",
                      src: PartnerScoreAssetConfig.driver_thumb_icon
                    }), React.createElement("div", {
                      className: "locked-slider-track-v2"
                    }, Belt_Array.mapWithIndex(track_thresholds, (function (index, val) {
                            return React.createElement("div", {
                                        className: "locked-slider-track-span-container-v2",
                                        style: {
                                          width: PartnerScoreV2CssHelper.getSliderSpanLength(max_score, Belt_Option.getWithDefault(Belt_Float.fromString(StringUtils.removeSymbolsFromString(val, ["%"])), 0), PartnerScoreHelper.getPrevScore(index, track_thresholds))
                                        }
                                      }, React.createElement(LockedSliderTrackMilestoneCmp.make, {
                                            track_thresholds: track_thresholds,
                                            current_score: current_score,
                                            max_score: max_score,
                                            action_details: action_details,
                                            index: index
                                          }), React.createElement(SliderTrackSpanCmp.make, {
                                            current_score: current_score,
                                            max_score: max_score,
                                            index: index
                                          }), React.createElement(SliderMarkingCmp.make, {
                                            index: index,
                                            val: val,
                                            track_thresholds: track_thresholds,
                                            max_score: max_score
                                          }));
                          })))));
}

var make = LockedScoreSliderV2;

export {
  make ,
  
}
/* react Not a pure module */
